import React from 'react';
import { motion } from 'framer-motion';
export function TwoOptions() {
  return <section className="py-20 bg-slate-50" data-id="element-380">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-381">
        <div className="text-center mb-12" data-id="element-382">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-383">
            TODAVÍA TENÉS DOS OPCIONES
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-384">
          <motion.div className="bg-white p-8 rounded-2xl shadow-md border border-slate-200 opacity-70" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 0.7,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-385">
            <div className="text-slate-400 font-bold mb-4 uppercase tracking-wider" data-id="element-386">
              OPCIÓN 1
            </div>
            <p className="text-lg text-slate-600" data-id="element-387">
              Seguir haciendo las cosas como hasta ahora y continuar sin saber
              exactamente cuánto dinero gana tu negocio.
            </p>
          </motion.div>

          <motion.div className="bg-navy-900 p-8 rounded-2xl shadow-xl border border-navy-700 text-white transform md:scale-105" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-388">
            <div className="text-success font-bold mb-4 uppercase tracking-wider" data-id="element-389">
              OPCIÓN 2
            </div>
            <p className="text-xl font-medium leading-relaxed" data-id="element-390">
              Implementar un sistema probado para recuperar el control de tus
              finanzas, organizar tus números y construir un negocio más
              rentable y estable.
            </p>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-391">
          <p className="text-2xl font-black text-navy-900 tracking-widest uppercase" data-id="element-392">
            LA DECISIÓN ES TUYA.
          </p>
        </div>
      </div>
    </section>;
}